import { CloseAction } from "../../shared/schema/AgentActionSchemas";
import { Streaming } from "../../shared/types/Streaming";
import { AgentActionUtil, registerActionUtil } from "./AgentActionUtil";

export const CloseActionUtil = registerActionUtil(
  class CloseActionUtil extends AgentActionUtil<CloseAction> {
    static override type = "close" as const;

    override getInfo() {
      return {
        icon: "cross-2" as const,
        description: "Closing the notepad",
      };
    }

    override savesToHistory(): boolean {
      return false;
    }

    override applyAction(action: Streaming<CloseAction>) {
      // Dispatch close event — the notepad store (Ali's Task A2) will handle this.
      // Using a custom event so this doesn't depend on the store existing yet.
      window.dispatchEvent(
        new CustomEvent("notepad:close", {
          detail: {
            summary: action.summary,
            timestamp: (action as Record<string, unknown>).timestamp,
          },
        }),
      );
    }
  },
);
